import { i18N } from "../helper";
const NAME = 'wc_product_dimensions';
const KEY = 'dimensions';
AC_SERVICES.addListener('Editing.Editables.Ready', (Editables) => {
    const Abstract = Editables.get('_abstract');
    class Dimensions extends Abstract {
        getLengthElement() {
            return this.getElement().querySelector('[name=length]');
        }
        getWidthElement() {
            return this.getElement().querySelector('[name=width]');
        }
        getHeightElement() {
            return this.getElement().querySelector('[name=height]');
        }
        focus() {
            this.getLengthElement().focus();
        }
        getEditableType() {
            return NAME;
        }
        valueToInput(value) {
            this.getLengthElement().focus();
            if (!value) {
                return;
            }
            this.getLengthElement().value = value.length;
            this.getWidthElement().value = value.width;
            this.getHeightElement().value = value.height;
        }
        getValue() {
            return {
                length: this.getLengthElement().value,
                width: this.getWidthElement().value,
                height: this.getHeightElement().value
            };
        }
        getTemplate() {
            const length = this.getEditableTemplate().getFormHelper().input('length', null, { type: 'number', step: 'any', min: 0, placeholder: i18N().length }).outerHTML;
            const width = this.getEditableTemplate().getFormHelper().input('width', null, { type: 'number', step: 'any', min: 0, placeholder: i18N().width }).outerHTML;
            const height = this.getEditableTemplate().getFormHelper().input('height', null, { type: 'number', step: 'any', min: 0, placeholder: i18N().height }).outerHTML;
            return `<div class="aceditable__form__inputs__dimensions">${length} ${width} ${height}</div>`;
        }
    }
    Editables.registerEditable('dimensions', Dimensions);
});
AC_SERVICES.addListener('Editing.Middleware.Ready', (Middleware) => {
    const Abstract = Middleware.getClass('_abstract');
    class Dimensions extends Abstract {
        getEditable() {
            return this.Editables.get(KEY);
        }
    }
    Middleware.register(KEY, Dimensions);
});
